/* app/ui/listing/story */

define(
	'app/ui/listing/story',[
		'jquery',
		'util/core',

		'app/ui/listing/filter',
		'app/ui/listing/pagination',

		'templayed',
		'text!templates/filtersummary.html',
		'text!templates/storylisting.html',
		'text!templates/pagination.html',

		'pubsub'
	],
	function ($, Core, Filter, Pagination, templayed, summaryTemplate, listingTemplate, paginationTemplate) {

		window.dataLayer = window.dataLayer || [];

		var selectors = Object.freeze({
			summaryContainer: '.js-summary-container',
			storyListingContainer: '.js-story-listing-container',
			paginationContainer: '.js-pagination-container',

			gtmStoryListingDetail: '.js-gtm-story-listing-detail',
			gtmStoryListingDetailFeature: '.js-gtm-story-listing-detail-feature',
		});

		var dataAttributes = Object.freeze({
			jsonUrl: 'data-json-url',
			storyName: 'data-story-name',
		});

		var classes = Object.freeze({
			open: 'is-open',
			hasOverlay: 'has-overlay',
		});

		var events = Object.freeze({
			storyListingUpdate: '/story/listing/update',
			storyListingOverlay: '/story/listing/overlay',
			storyFeedLoaded: '/story/feed/loaded',

			paginationUpdate: 'pagination/update',
		});

		var historySupport = window.history && window.history.pushState;

		var firstLoad = true;
		var fromHistory = false;

		var $listingContainer;
		var $filterSummaryContainer;
		var $storyListContainer;
		var $paginationContainer;

		var baseJsonUrl;

		var feedData = {};
		var queryObj = {};
		var perPage = Number.MAX_SAFE_INTEGER;

		var module = {
			init: function ($elms) {
				$listingContainer = $elms.eq(0);
				baseJsonUrl = $listingContainer.attr(dataAttributes.jsonUrl);
				queryObj = Core.getQueryStringObject();

				summaryTemplate = summaryTemplate.replace(/\r/g, '');
				listingTemplate = listingTemplate.replace(/\r/g, '');
				paginationTemplate = paginationTemplate.replace(/\r/g, '');

				Filter.init($listingContainer, classes);
				Pagination.init($listingContainer);

				module._initElements();
				module._initSubscriptions();
				module._initEvents();

				var firstFetchUrl = baseJsonUrl;
				if (baseJsonUrl !== '') {
					if (queryObj.queryString !== '') {
						if (firstFetchUrl.indexOf('?') !== -1) {
							firstFetchUrl += '&';
						} else {
							firstFetchUrl += '?';
						}
						firstFetchUrl += queryObj.queryString;
					}
					module._fetchFeedData(firstFetchUrl);
				}
			},

			_initElements: function () {
				$filterSummaryContainer = $listingContainer.find(selectors.summaryContainer);
				$storyListContainer = $listingContainer.find(selectors.storyListingContainer);
				$paginationContainer = $listingContainer.find(selectors.paginationContainer);
			},

			_initSubscriptions: function () {
				$.subscribe(events.storyListingUpdate, module._initListing);
				$.subscribe(events.storyListingOverlay, module._toggleListingStatus);
				$.subscribe(events.paginationUpdate, module._onPaginationUpdate);
			},

			_initEvents: function () {
				window.onpopstate = module._processPopState;

				$listingContainer.on('click', selectors.gtmStoryListingDetail, module._trackDetailClick);
				$listingContainer.on('click', selectors.gtmStoryListingDetailFeature, module._trackDetailFeatureClick);
			},

			_processPopState: function (event) {
				var state = event.state;

				if (state) {
					fromHistory = true;
					feedData = state.data;
					Filter.updateFilters(feedData.queryObj);
					module._updateListing(state.data.pagination);
					$.publish(events.storyFeedLoaded, [feedData]);
				}
			},

			// Update listing when new filters are applied
			_initListing: function (queryData) {
				queryObj = queryData;
				fromHistory = false;

				var queryChar = baseJsonUrl.indexOf('?') === -1 ? '?' : '&';

				var url = baseJsonUrl + queryChar + queryObj.queryString;
				module._fetchFeedData(url);
			},

			// Fetch feed data from AjaxController
			_fetchFeedData: function (url) {
				$.ajax({
						url: url,
						dataType: 'json'
					})
					.done(
						module._fetchFeedDataComplete
					)
					.fail(
						module._fetchFeedDataError
					);
			},

			// Process feed data
			_fetchFeedDataComplete: function (data) {
				feedData = data;
				var hasResults = feedData.Count >= 1;
				var hasPagination = feedData.Count > perPage;

				if (firstLoad) {
					feedData.queryObj = Core.getQueryStringObject();
				} else {
					feedData.queryObj = queryObj;
				}

				feedData.hasPagination = hasPagination;
				feedData.hasResults = hasResults;
				feedData.noResults = !hasResults;
				feedData.pageSize = perPage;
				feedData.pagination = Pagination.getPagingData(feedData);

				$.publish(events.storyFeedLoaded, [feedData]);

				if (!firstLoad) {
					module._updateListing(feedData.pagination);
				}

				if (firstLoad && historySupport) {
					history.replaceState({ data: feedData }, document.title, document.location);
					firstLoad = false;
				}
			},

			_fetchFeedDataError: function () {
				console.error('There was an error retrieving feed data.');
				// Unbind pagination / filtering events
			},

			_onPaginationUpdate: function (pagingData) {
				fromHistory = false;
				module._updateListing(pagingData);
			},

			// Pagination updated
			// Get the new set of items to show
			// Construct a new summary object
			// Compile + inject listing template
			// Compile + inject summary template
			_updateListing: function (pagingData) {
				feedData.pagination = pagingData;

				var itemsToShow = feedData.Listings.slice(pagingData.pageStart - 1, pagingData.pageEnd);
				var summaryObj = {
					hasResults: pagingData.pageEnd > 0,
					pageStart: Math.min(pagingData.pageStart, pagingData.total).toString(),
					pageEnd: Math.min(pagingData.pageEnd, pagingData.total).toString(),
					total: pagingData.total.toString(),
					noResults: pagingData.pageEnd === 0,
					dropdownFilters: feedData.queryObj.dropdownFilters,
					inputFilters: feedData.queryObj.inputFilters,
					checkboxFilters: feedData.queryObj.checkboxFilters
				};

				var i;
				var item;
				for (i = 0; i < itemsToShow.length; i++) {
					item = itemsToShow[i];
					item.HasAbstract = !!item.Abstract;
				}

				var compiledSummary = templayed(summaryTemplate)(summaryObj);

				var compiledListing = templayed(listingTemplate)({ Listings: itemsToShow, HasListings: !!itemsToShow.length });
				var url = module._constructHistoryUrl(pagingData.currentPage);

				$filterSummaryContainer.html(compiledSummary);
				$storyListContainer.html(compiledListing);
				$paginationContainer.empty();

				if (pagingData.total > perPage) {
					var compiledPagination = templayed(paginationTemplate)(pagingData);
					$paginationContainer.html(compiledPagination);
				}

				if (historySupport && !fromHistory) {
					history.pushState({ data: feedData }, document.title, url);
				}

				Core.scrollToElm($listingContainer);
			},

			_toggleListingStatus: function () {
				$listingContainer.toggleClass(classes.hasOverlay);
			},

			_constructHistoryUrl: function (currentPage) {
				var url = '';

				if (feedData.queryObj.queryString !== '') {
					url = '?' + feedData.queryObj.queryString;

					if (currentPage > 1) {
						url += '&page=' + currentPage;
					}
					return url;
				}

				return currentPage > 1 ? '?page=' + currentPage : document.location.pathname;
			},

			_trackDetailClick: function (e) {
				var $link = $(e.target);
				var storyName = $link.text() || $link.attr(dataAttributes.storyName);

				window.dataLayer.push({
					'event': 'customEvent',
					'eventDetails': {
						'category': 'Story Listing',
						'action': 'View Detail',
						'label': 'Story: ' + storyName + ', Page: ' + document.location.href
					}
				});
			},
			_trackDetailFeatureClick: function (e) {
				var $link = $(e.target);
				var storyName = $link.text() || $link.attr(dataAttributes.storyName);

				window.dataLayer.push({
					'event': 'customEvent',
					'eventDetails': {
						'category': 'Story Listing',
						'action': 'Feature View Detail',
						'label': 'Story: ' + storyName + ', Page: ' + document.location.href
					}
				});
			},
		};

		return {
			init: module.init
		};
	}
);
